import { createContext, useContext, useState, type ReactNode } from 'react';
import type { Request, Touchpoint } from '../types';
export type SyncStatus = 'idle' | 'loading' | 'success' | 'error' | 'never';
interface RequestsCtxValue {
  requests: Request[];
  setRequests: (requests: Request[]) => void;
  touchpoints: Touchpoint[];
  setTouchpoints: (touchpoints: Touchpoint[]) => void;
  isLiveData: boolean;
  syncStatus: SyncStatus;
  lastSynced: string | null;
  setSyncMeta: (status: SyncStatus, lastSynced?: string | null) => void;
}
const RequestsContext = createContext<RequestsCtxValue>({
  requests: [],
  setRequests: () => {},
  touchpoints: [],
  setTouchpoints: () => {},
  isLiveData: false,
  syncStatus: 'idle',
  lastSynced: null,
  setSyncMeta: () => {}
});
export function useRequests(): RequestsCtxValue {
  return useContext(RequestsContext);
}
export function RequestsProvider({
  children
}: {
  children: ReactNode;
}) {
  const [requests, setRequestsState] = useState<Request[]>([]);
  const [touchpoints, setTouchpointsState] = useState<Touchpoint[]>([]);
  const [isLiveData, setIsLiveData] = useState(false);
  const [syncStatus, setSyncStatusState] = useState<SyncStatus>('idle');
  const [lastSynced, setLastSynced] = useState<string | null>(null);
  const setRequests = (r: Request[]) => {
    setRequestsState(r);
    setIsLiveData(true);
  };
  const setTouchpoints = (t: Touchpoint[]) => {
    console.log('[RequestsContext] setTouchpoints:', t.length, 'touchpoints');
    setTouchpointsState(t);
  };
  const setSyncMeta = (status: SyncStatus, ts?: string | null) => {
    setSyncStatusState(status);
    if (ts !== undefined) setLastSynced(ts ?? null);
  };
  return <RequestsContext.Provider value={{
    requests,
    setRequests,
    touchpoints,
    setTouchpoints,
    isLiveData,
    syncStatus,
    lastSynced,
    setSyncMeta
  }} data-id="element-1311" data-mp="3dju7d58duhbj">
      {children}
    </RequestsContext.Provider>;
}

// Legacy export aliases for gradual migration
export const DealsContext = RequestsContext;
export const useDeals = useRequests;
export const DealsProvider = RequestsProvider;
export type DealsCtxValue = RequestsCtxValue;